module.exports = __webpack_public_path__ + "img/DiHS_Icon_Wartebereich_60_2.80d3ffad.svg";